import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}


// 获取期刊&研究报告分类
export async function getEbookCategory(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/get_ebook_category", params);
    } catch (error) {
        return error;
    }
}
// 获取期刊&研究报告列表
export async function getEbookList(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/get_ebook_list", params);
    } catch (error) {
        return error;
    }
}

// 我要投稿

export async function addEbookApply(params) {
    try {
        return await API.post("api/" + prout + "/api/ebook/add", params);
    } catch (error) {
        return error;
    }
}

// 期刊详情

export async function getEbookInfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/ebookInfo", params);
    } catch (error) {
        return error;
    }
}

export async function getEbookArticleList(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/ebookArticleList", params);
    } catch (error) {
        return error;
    }
}

export async function getEbookPreviousList(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/ebookPreviousList", params);
    } catch (error) {
        return error;
    }
}
export async function journalStats(params) {
    try {
        return await API.post("/api/" + prout + "/api/ebook/journalStats", params);
    } catch (error) {
        return error;
    }
}





